import { useState, useEffect } from "react";
import React from "react";
import ReactSelect from "react-select";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  Box,
  Button,
  Container,
  Typography,
  Grid,
  Input,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormGroup,
} from "@mui/material";
import Moment from "moment";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import DescriptionIcon from "@mui/icons-material/Description";
const PreviewClaim = (props) => {
  const rights = useSelector((state) => state.login.rights);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = { Authorization: auth };
  const alert = useAlert();

  const [charges, setCharges] = useState("");
  const [charges1, setCharges1] = useState("");
  const [charges2, setCharges2] = useState("");
  const [charges3, setCharges3] = useState("");
  const [code, setCode] = useState("");
  const [code1, setCode1] = useState("");
  const [code2, setCode2] = useState("");
  const [code3, setCode3] = useState("");
  const [UNIT, setUNIT] = useState("");
  const [UNIT1, setUNIT1] = useState("");
  const [UNIT2, setUNIT2] = useState("");
  const [UNIT3, setUNIT3] = useState("");
  const [ProcedureID, setProcedureID] = useState(0);
  const [ProcedureID1, setProcedureID1] = useState(0);
  const [ProcedureID2, setProcedureID2] = useState(0);
  const [ProcedureID3, setProcedureID3] = useState(0);
  const [d, setD] = useState([]);
  const [d1, setD1] = useState([]);
  const [d2, setD2] = useState([]);
  const [d3, setD3] = useState([]);
  const [dxPointer, setdxPointer] = useState([]);
  const [dxPointer1, setdxPointer1] = useState([]);
  const [dxPointer2, setdxPointer2] = useState([]);
  const [dxPointer3, setdxPointer3] = useState([]);
  const [dos, setDos] = useState("");
  const [Dos, setDOS] = useState("");
  const [dos1, setDos1] = useState("");
  const [dos2, setDos2] = useState("");
  const [dos3, setDos3] = useState("");
  const [claimId] = useState(props.claimId);
  const [submitting, setSubmitting] = useState(false);
  const [patientid, setPatientid] = useState(false);
  const [patientInsuranceName, setPatientInsuranceName] = useState("");
  const [patientAddress, setPatientAddress] = useState("");
  const [patientCity, setPatientCity] = useState("");
  const [patientState, setPatientState] = useState("");
  const [patienZip, setPatientZip] = useState("");
  const [patientDOB, setPatientDOB] = useState(Moment().format("YYYY-MM-DD"));
  const [PatientName, setPatientName] = useState("");
  const [memberid, setMemberid] = useState("");
  const [SecondarMemberid, setSecondarMemberid] = useState("");
  const [SecondarInsuranceName, setSecondarInsuranceName] = useState("");
  const [diagnosisList, setDiagnosisList] = useState([]);
  const [procedureCodeList, setProcedureCodeList] = useState([]);
  const [referringPhysicianList, setReferringPhysicianList] = useState([]);
  const [providers, setProviders] = useState([]);
  const [taxId, setTaxId] = useState("");
  const [npi, setNpi] = useState("");
  const [referringProviderNpi, setReferringProviderNpi] = useState("");
  const [providerError, setProviderError] = useState(false);
  const [assignmentError, setAssignmentError] = useState("");
  const [procedureError, setProcedureError] = useState("");
  const [diagnosisError, setDiagnosisError] = useState("");

  // NEW STATES FOR CMS-1500 FORM
  const [patientRelationship, setPatientRelationship] = useState("Self");
  const [insuredName, setInsuredName] = useState("");
  const [insuredAddress, setInsuredAddress] = useState("");
  const [insuredDOB, setInsuredDOB] = useState("");
  const [insuredSex, setInsuredSex] = useState("M");
  const [priorAuthorization, setPriorAuthorization] = useState("");
  const [signatureDate, setSignatureDate] = useState(
    Moment().format("YYYY-MM-DD")
  );
  const [serviceFacilityInfo, setServiceFacilityInfo] = useState("");
  const [billingProvider, setbillingProvider] = useState(null);
  const [ProviderState, setProviderState] = useState("");
  const [ProviderZip, setProviderZip] = useState("");
  const [Providerphone, setProviderphone] = useState("");
  const [ProviderAddress, setProviderAddress] = useState("");
  const [totalCharge, setTotalCharge] = useState("0.00");
  const [amountPaid, setAmountPaid] = useState("0.00");
  const [balanceDue, setBalanceDue] = useState("0.00");
  const [insuranceType, setInsuranceType] = useState({
    medicare: false,
    medicaid: false,
    tricare: false,
    champva: false,
    groupHealthPlan: false,
    feca: false,
    other: false,
  });
  const [diagnosisCodes, setDiagnosisCodes] = useState({});

  // Form Configuration
  const validationSchema = Yup.object({
    dos: Yup.string().required("DOS is required"),
    patientName: Yup.string().required("Patient is required"),
  });
  const defValues = {
    id: 0,
    patientId: 0,
    billingProvider: 0,
    attendingPhysician: 0,
    insuranceName: "",
    memberId: 0,
    referringPhysician: 0,
    practiceId: "",
    patientName: "",
    patientName: "",
    dos: "",
    dos1: "",
    dos2: "",
    pos: "",
    frontnote: "",
    amountDue: 0,
    discount: 0,
    writeOff: 0,
    claimTotal: 0,
    amountPaid: 0,
    amountAllowed: 0,
    totalCharges: 0,
    adjustments: 0,
    backnote: "",
    referringPhysicianName: "",
    referringPhysicianId: 0,
    renderingProvider: "",
    cpt1: "",
    cpt2: "",
    cpt3: "",
    charges1: "",
    charges2: "",
    charges3: "",
    authNumber: "",
    acceptAssignment: "",
    dontAcceptAssignment: "",
    // defaultTwoweek: "",
    // FollowUp5Days: "",
    // FollowUp10Days: "",
    followUpTime: "14",
    secondaryPending: "",
    additionalInformation: "",
    submitted: false,
    payment: false,
    Carries: "",
    referringProvider: "",
    createdDate: "",
    updatedDate: "",
    compeleted: false,
    statusType: "Pending",
    diagnosis: {
      id: 0,
      claimId: 0,
      diagSequence: 0,
      description: "",
      code: "",
      dx1: "",
      dx2: "",
      dx3: "",
      dx4: "",
      dx5: "",
      dx6: "",
      dx7: "",
      dx8: "",
      dx9: "",
      dx10: "",
      dx11: "",
      dx12: "",
      patientId: 0,
    },
  };
  const {
    register,
    control,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  const attendingPhysician = watch("attendingPhysician");
  const referringPhysician = watch("referringPhysician");
  const practiceID = localStorage.getItem("default_paractice");
  const User_Type = localStorage.getItem("User_Type");
  const claimPracticeID = props.claimPracticeID;
  const PatientidOfClaim = props.claimpatientId || props.patientId;

  const Label = ({ text }) => (
    <div style={{ fontSize: 11, fontWeight: "bold", marginBottom: 3 }}>
      {text}
    </div>
  );
  const Input = ({ value = "", onChange, placeholder = "", type = "text" }) => (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      style={{
        width: "100%",
        border: "1px solid #999",
        padding: "3px",
        fontSize: 11,
        height: 24,
        boxSizing: "border-box",
      }}
    />
  );

  const selectStyle = {
    width: "100%",
    border: "1px solid #999",
    padding: "2px",
    fontSize: 11,
    height: 24,
  };

  const cellStyle = {
    border: "1px solid #000",
    padding: "5px",
    verticalAlign: "top",
  };
  // Calculate total charges
  useEffect(() => {
    const total =
      (parseFloat(charges) || 0) +
      (parseFloat(charges1) || 0) +
      (parseFloat(charges2) || 0) +
      (parseFloat(charges3) || 0);
    setTotalCharge(total.toFixed(2));
    setBalanceDue((total - (parseFloat(amountPaid) || 0)).toFixed(2));
  }, [charges, charges1, charges2, charges3, amountPaid]);
  const acceptAssignment = watch("acceptAssignment");
  const dontAcceptAssignment = watch("dontAcceptAssignment");
  // Load patient data
  useEffect(() => {
    if (patientid > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patients/SearchInsuranceName?patientId=${patientid}`,
          { headers }
        )
        .then((response) => {
          const Data = response[0] || {};
          const fullAddress = [
            Data.address,
            Data.city,
            Data.state,
            Data.zipCode,
          ]
            .filter(Boolean)
            .join(", ");

          const primary = response.find(
            (r) => r.type?.toLowerCase() === "primary"
          );
          const secondary = response.find(
            (r) => r.type?.toLowerCase() === "secondary"
          );

          setPatientInsuranceName(primary?.planName || "");
          setPatientAddress(fullAddress);
          setPatientDOB(Moment(Data.dob).format("YYYY-MM-DD"));
          setMemberid(primary?.memberId || "");
          setPatientName(Data.patientName || "");
          setInsuredName(Data.patientName || "");
          setPatientZip(Data?.zipCode);
          setPatientCity(Data?.city);
          setPatientState(Data?.state);
          setInsuredAddress(fullAddress);
          setInsuredDOB(Moment(Data.dob).format("YYYY-MM-DD"));
          setSecondarInsuranceName(secondary?.planName || "");
          setSecondarMemberid(secondary?.memberId || "");

          // Set default values
          setValue("patientName", Data.patientName || "");
          setValue("insuranceName", primary?.planName || "");
        })
        .catch((error) => {
          console.error("Error loading patient data:", error);
        });
    }
  }, [patientid]);
  const [diagnosisLoaded, setDiagnosisLoaded] = useState(false);

  useEffect(() => {
    // Fetch diagnosis list
    axios
      .get(`${process.env.REACT_APP_API_URL}/Diagnosis/Diagnosis`, { headers })
      .then((response) => {
        const diagnosisOptions = response.map((field) => ({
          label: field.code,
          value: field.id,
        }));
        setDiagnosisList(diagnosisOptions);
        setDiagnosisLoaded(true);
      })
      .catch(console.error);

    // Fetch procedure codes
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/Procedures`, {
        headers,
      })
      .then((response) => {
        const procedureOptions = response.map((field) => ({
          label: `${field.code} - ${field.description}`,
          value: field.code,
          qasim: field.default_charges,
          unit: field.unit,
          description: field.description,
          placeOfService: field.placeOfService,
        }));
        setProcedureCodeList(procedureOptions);
      })
      .catch(console.error);
  }, []);
  const getLabel = (id) => {
    const found = diagnosisList.find(
      (item) => String(item.value) === String(id)
    );
    return found ? found.label : id;
  };
  // Load claim data
  useEffect(() => {
    if (claimId > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/claims/ClaimsById?claimId=${claimId}`,
          { headers }
        )
        .then((response) => {
          const claimData = response;
          // Set basic form values
          Object.keys(claimData).forEach((key) => {
            if (key in getValues()) {
              setValue(key, claimData[key]);
            }
          });
          setValue("acceptAssignment", claimData.acceptAssignment);
          setValue("dontAcceptAssignment", claimData.dontAcceptAssignment);
          setValue("referringPhysician", claimData.referringPhysician);
          setPatientid(claimData.patientId);
          setPriorAuthorization(claimData.authNumber);
          // Format DOS
          const dateto342 = Moment(claimData.dos).format("YYYY-MM-DD");
          setDOS(dateto342);

          // Load procedures
          const procedures = claimData.procedures || [];

          if (procedures[0]) {
            setCharges(procedures[0].charges || "");
            setCode(procedures[0].code || "");
            setD(
              procedures[0].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || []
            );
            setdxPointer(
              procedures[0].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || []
            );
            const rawDates = procedures[0]?.dosTo;
            const dateto1 = Moment(rawDates, Moment.ISO_8601, true).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos(dateto1);
            setProcedureID(procedures[0].id || 0);
            setValue("cpt1", procedures[0].code || "");
          }
          if (procedures[1]) {
            setCharges1(procedures[1].charges || "");
            setCode1(procedures[1].code || "");
            setD1(
              procedures[1].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || []
            );
            const rawDates = procedures[1]?.dosTo;
            const dateto2 = Moment(rawDates, Moment.ISO_8601, true).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos1(dateto2);
            setProcedureID1(procedures[1].id || 0);
            setValue("cpt2", procedures[1].code || "");
            setdxPointer1(
              procedures[1].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || []
            );
          }
          if (procedures[2]) {
            setCharges2(procedures[2].charges || "");
            setCode2(procedures[2].code || "");
            setD2(
              procedures[2].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || []
            );
            const rawDates = procedures[2]?.dosTo;
            const dateto342123 = Moment(
              rawDates,
              Moment.ISO_8601,
              true
            ).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos2(dateto342123);
            setProcedureID2(procedures[2].id || 0);
            setValue("cpt3", procedures[2].code || "");
            setdxPointer2(
              procedures[2].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || []
            );
          }
          if (procedures[3]) {
            setCharges3(procedures[3].charges || "");
            setCode3(procedures[3].code || "");
            setD3(
              procedures[3].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || []
            );
            const rawDates = procedures[3]?.dosTo;
            const dateto342123 = Moment(
              rawDates,
              Moment.ISO_8601,
              true
            ).isValid()
              ? Moment(rawDates).format("YYYY-MM-DD")
              : "";
            setDos3(dateto342123);
            setProcedureID3(procedures[3].id || 0);
            setValue("cpt3", procedures[3].code || "");
            setdxPointer3(
              procedures[3].dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean) || []
            );
          }
          if (procedures.length > 0) {
            const tempDiagnosisCodes = {
              A: "",
              B: "",
              C: "",
              D: "",
              E: "",
              F: "",
              G: "",
              H: "",
              I: "",
              J: "",
              K: "",
              L: "",
            };

            procedures.forEach((proc, index) => {
              const dxArray = proc.dxPointer1
                ?.split(",")
                .map((code) => code.trim())
                .filter(Boolean);

              if (dxArray) {
                dxArray.forEach((code, i) => {
                  const letter = String.fromCharCode(65 + i + index * 4); // A–L sequential
                  if (letter <= "L")
                    tempDiagnosisCodes[letter] = getLabel(code);
                });
              }
            });

            setDiagnosisCodes(tempDiagnosisCodes);
          }

          // Load total charges
          if (claimData.totalCharges) {
            setTotalCharge(parseFloat(claimData.totalCharges).toFixed(2));
          }
          if (claimData.amountPaid) {
            setAmountPaid(parseFloat(claimData.amountPaid).toFixed(2));
          }
          if (claimData.amountDue) {
            setBalanceDue(parseFloat(claimData.amountDue).toFixed(2));
          }
        })
        .catch((error) => {
          console.error("Error loading claim:", error);
        });
    }
  }, [claimId, diagnosisLoaded]);

  useEffect(() => {
    const endpoint =
      !claimPracticeID || claimPracticeID === practiceID
        ? `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?parcticeid=${practiceID}`
        : `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?patientid=${PatientidOfClaim}`;

    axios
      .get(endpoint, { headers })
      .then((response) => {
        const referringOptions = response.map((field) => ({
          label: `${field.lastName}, ${field.firstName} (NPI: ${field.npi})`,
          value: field.id,
          npi: field.npi,
          lastName: field.lastName,
          firstName: field.firstName,
        }));
        setReferringPhysicianList(referringOptions);
      })
      .catch(console.error);
  }, [practiceID, PatientidOfClaim, claimPracticeID]);

  // Load providers
  useEffect(() => {
    const endpoint =
      !claimPracticeID || claimPracticeID === practiceID
        ? `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?parcticeid=${practiceID}`
        : `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?patientid=${PatientidOfClaim}`;

    axios
      .get(endpoint, { headers })
      .then((response) => {
        const providerOptions = response.map((field) => ({
          label: field.name || `${field.lastName}, ${field.firstName}`,
          value: field.id,
          npi: field.npi || field.nPI,
          taxId: field.taxId,
          billingProvider: field.isbillingProvider,
          address: field.address,
          zipCode: field.zipcode,
          state: field.state,
          phone: field.phone,
        }));
        setProviders(providerOptions);
      })
      .catch(console.error);
  }, [practiceID, claimPracticeID, PatientidOfClaim]);

  // Set provider NPI and Tax ID when attending physician changes
  useEffect(() => {
    if (attendingPhysician && providers.length > 0) {
      const selectedProvider = providers.find(
        (option) => option.value === attendingPhysician
      );
      if (selectedProvider) {
        setNpi(selectedProvider.npi || "");
        setTaxId(selectedProvider.taxId || "");
        setbillingProvider(selectedProvider.billingProvider);
        setProviderAddress(selectedProvider.address);
        setProviderphone(selectedProvider.phone);
        setProviderZip(selectedProvider.zipCode);
        setProviderState(selectedProvider.state);
      }
    }
  }, [attendingPhysician, providers]);

  // Set referring provider NPI
  useEffect(() => {
    if (referringPhysician && referringPhysicianList.length > 0) {
      const selected = referringPhysicianList.find(
        (p) => String(p.value) === String(referringPhysician)
      );
      if (selected) {
        setReferringProviderNpi(selected.npi || "");
      }
    }
  }, [referringPhysicianList, referringPhysician]);

  // Submit Handler
  const onSubmit = (data) => {
    let isValid = true;

    if (!code) {
      setProcedureError("At least one procedure code is required.");
      isValid = false;
    } else {
      setProcedureError("");
    }

    if (d.length === 0) {
      setDiagnosisError("At least one diagnosis code is required.");
      isValid = false;
    } else {
      setDiagnosisError("");
    }

    if (!attendingPhysician) {
      setProviderError("Provider is required.");
      isValid = false;
    } else {
      setProviderError("");
    }

    if (!data.acceptAssignment && !data.dontAcceptAssignment) {
      setAssignmentError("Please select assignment option.");
      isValid = false;
    } else {
      setAssignmentError("");
    }

    if (!isValid) {
      alert.error("Please fill all required fields.");
      return;
    }

    // Prepare diagnosis codes for Box 21
    const diagCodes = Object.values(diagnosisCodes).filter(
      (code) => code.trim() !== ""
    );

    // Prepare post data
    const postData = {
      ...data,
      acceptAssignment: data.acceptAssignment === true,
      dontAcceptAssignment: data.dontAcceptAssignment === true,
      payment: false,
      authNumber: data.authNumber || priorAuthorization,
      practiceId: practiceID,
      Carries: data.insuranceName,
      insuranceName: data.insuranceName,
      patientName: data.patientName,
      patientId: patientid > 0 ? patientid : 0,
      totalCharges: parseFloat(totalCharge),
      amountPaid: parseFloat(amountPaid),
      amountDue: parseFloat(balanceDue),
      attendingPhysician: data.attendingPhysician,
      referringPhysician: data.referringPhysician,
    };

    // Prepare procedures
    const DiagnosisCode = [
      Array.isArray(dxPointer) ? dxPointer.join(",") : "",
      Array.isArray(dxPointer1) ? dxPointer1.join(",") : "",
      Array.isArray(dxPointer2) ? dxPointer2.join(",") : "",
      Array.isArray(dxPointer3) ? dxPointer3.join(",") : "",
    ];

    const DOS = [dos, dos1, dos2, dos3];
    const ProcedureIDs = [
      ProcedureID,
      ProcedureID1,
      ProcedureID2,
      ProcedureID3,
    ];
    const Code = [code, code1, code2, code3];
    const Charges = [charges, charges1, charges2, charges3];
    const UNits = [UNIT, UNIT1, UNIT2, UNIT3];

    postData.procedures = Code.filter((code, index) => code).map(
      (code, index) => ({
        code,
        charges: Charges[index] || null,
        dosTo: DOS[index] || null,
        dxPointer1: DiagnosisCode[index] || null,
        id: ProcedureIDs[index] || 0,
        claimId: claimId,
        units: UNits[index] || 0,
      })
    );

    setSubmitting(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addclaims`, postData, {
        headers,
      })
      .then((response) => {
        setSubmitting(false);
        props.handleClosePreview();
        setTimeout(() => {
          alert.success("CMS-1500 Claim saved successfully.", {
            type: "success",
          });
        }, 500);
      })
      .catch((error) => {
        setSubmitting(false);
        props.handleClosePreview();
        alert.error("Error saving claim. Please try again.", {
          type: "error",
        });
        console.error("Submit error:", error);
      });
  };

  const handleDiagnosisCodeChange = (letter, value) => {
    setDiagnosisCodes((prev) => ({
      ...prev,
      [letter]: value,
    }));
  };
  const claimMdFieldStyle = {
    backgroundColor: "#dcd9d9ff", // grey field background
    padding: "2px 6px",
    borderRadius: "4px",

    "& .MuiInputBase-input": {
      fontSize: "12px",
      padding: "4px 0px",
      color: "#0261c0ff", // blue text
      fontWeight: 600,
    },

    "& .MuiInputLabel-root": {
      fontSize: "13px",
      color: "#666",
    },

    "& .MuiInputLabel-root.Mui-focused": {
      color: "#1976d2",
    },

    "& .MuiInput-underline:before": {
      borderBottomColor: "#1976d2",
    },

    "& .MuiInput-underline:hover:before": {
      borderBottomColor: "#115293",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#1976d2",
    },
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#dcd9d9ff",
      minHeight: "34px",
      height: "34px",
      borderRadius: "4px",
      border: "none",
      boxShadow: state?.isFocused ? "0 0 0 1px #1976d2" : "none",
      padding: "0 6px",
      display: "flex",
      alignItems: "center",
      width: "100%", // fixed width according to container
      maxWidth: "100%", // prevent auto expand
      "&:hover": {
        borderColor: "#115293",
      },
    }),

    valueContainer: (base, state) => ({
      ...base,
      padding: "0 6px",
      display: "flex",
      flexWrap: "nowrap", // single line
      overflowX: state?.isMulti ? "auto" : "hidden", // horizontal scroll if multi
      alignItems: "center",
      height: "34px",
      minHeight: "34px",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#0261c0ff",
      fontWeight: 600,
      fontSize: "12px",
      lineHeight: "34px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis", // truncate if too long
    }),

    placeholder: (base) => ({
      ...base,
      color: "#666",
      fontSize: "12px",
      lineHeight: "34px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),

    multiValue: (base) => ({
      ...base,
      backgroundColor: "#1976d2",
      color: "#fff",
      borderRadius: "2px",
      padding: "0 4px",
      margin: "0 4px 0 0",
      fontSize: "8px",
      fontWeight: 400,
      maxWidth: "100%", // prevent expand
      overflow: "hidden",
    }),

    multiValueLabel: (base) => ({
      ...base,
      color: "#fff",
      fontSize: "8px",
      fontWeight: 300,
      padding: "2px 2px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),

    multiValueRemove: (base) => ({
      ...base,
      color: "#fff",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#115293",
        color: "#fff",
      },
    }),

    input: (base) => ({
      ...base,
      color: "#0261c0ff",
      fontSize: "12px",
      margin: 0,
      padding: 0,
    }),

    dropdownIndicator: (base) => ({
      ...base,
      padding: "4px",
      color: "#1976d2",
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    menu: (base) => ({
      ...base,
      zIndex: 9999,
      fontSize: "12px",
    }),

    option: (base, state) => ({
      ...base,
      fontSize: "12px",
      color: state?.isSelected ? "#fff" : "#0261c0ff",
      backgroundColor: state?.isSelected
        ? "#1976d2"
        : state?.isFocused
        ? "#e6eef9"
        : "#fff",
      padding: "6px 12px",
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  const simpleSelectStyle = {
    control: (base) => ({
      ...base,
      minHeight: "24px",
      height: "30px",
      borderRadius: "2px",
      border: "1px solid #999",
      boxShadow: "none",
      backgroundColor: "#fff",
      padding: "0 4px",
      width: "100%",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 4px",
      height: "24px",
      minHeight: "24px",
      display: "flex",
      flexWrap: "wrap",
      overflow: "hidden",
      gap: "2px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "11px",
      lineHeight: "24px",
      color: "#000",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "11px",
      lineHeight: "24px",
      color: "#000",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#dcdcdc",
      borderRadius: "2px",
      padding: "0 2px",
      margin: "0 2px 0 0",
      height: "18px",
      display: "flex",
      alignItems: "center",
    }),
    multiValueLabel: (base) => ({
      ...base,
      fontSize: "9px",
      padding: "0 2px",
      lineHeight: "16px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      fontSize: "10px",
      padding: "0 2px",
      cursor: "pointer",
      color: "#555",
      "&:hover": {
        backgroundColor: "#aaa",
        color: "#fff",
      },
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      fontSize: "11px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (base) => ({
      ...base,
      fontSize: "11px",
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "11px",
      color: "#000",
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      padding: "4px 8px",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  const [PriPayerId, setPriPayerId] = useState("");
  const [SecPayerId, setSecPayerId] = useState("");
  const [SecRelation, setSecRelation] = useState("");
  const [PriRelation, setPriRelation] = useState("");
  const [PatientSex, setPatientSex] = useState("");

  useEffect(() => {
    if (patientid > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patients/getPatientById?id=${
            patientid !== undefined ? patientid : 0
          }`,
          { headers }
        )
        .then((response) => {
          setPriPayerId(response?.priIns?.payerId);
          setSecPayerId(response?.secIns?.payerId);
          setPatientSex(response?.gender);
          setPriRelation(response?.priIns?.subsRelation);
          setSecRelation(response?.secIns?.subsRelation);
        })
        .catch((error) => {});
    }
  }, [patientid]);
  const [PracticeName, setPracticeName] = useState("");
  const [PracticeAddress, setPracticeAddress] = useState("");
  const [PracticeZipcode, setPracticeZipcode] = useState({
    city: "",
    state: "",
    zipCode: "",
  });
  useEffect(() => {
    if (practiceID > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Practices/getPracticeById?id=${
            practiceID !== undefined ? practiceID : 0
          }`,
          { headers }
        )
        .then((response) => {
          setPracticeName(response.practiceName);
          setPracticeAddress(response.address);
          setPracticeZipcode({
            city: response.city || "",
            state: response.state || "",
            zipCode: response.zipCode || "",
          });
        })
        .catch((error) => {});
    }
  }, [practiceID]);
  return (
    <>
   <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 16px",
    backgroundColor: "#1976d2", // blue header
    color: "#fff",
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  }}
>
  {/* Left: Icon + Label */}
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <DescriptionIcon style={{ fontSize: 24 }} />
    <Typography variant="h6" component="span" style={{ fontWeight: "bold" }}>
      Claim Submission Form
    </Typography>
  </div>

  {/* Right: Close Icon */}
  <IconButton
    size="small"
     onClick={props.handleClosePreview}
    sx={{
      color: "#fff",
      backgroundColor: "rgba(255,255,255,0.1)",
      "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
    }}
  >
    <CancelOutlinedIcon />
  </IconButton>
</div>
    <TableContainer>
      <Table
        sx={{
          borderCollapse: "collapse",
          border: "1px solid #000",
          tableLayout: "fixed",
        }}
      >
        <TableBody>
          {/* ================= ROW 1 ================= */}
          <TableRow>
            <TableCell colSpan={2} sx={cellStyle}>
              <div style={{ display: "flex", gap: 6 }}>
                <div style={{ flex: 4 }}>
                  <Label text="1. PAYER NAME" />
                  <Input
                    value={patientInsuranceName}
                    onChange={(e) => {
                      setPatientInsuranceName(e.target.value);
                      setValue("Carries", e.target.value);
                      setValue("insuranceName", e.target.value);
                    }}
                  />
                </div>

                <div style={{ flex: 2 }}>
                  <Label text="PAYER ID " />
                  <Input value={PriPayerId} />
                </div>

                <div style={{ flex: 2 }}>
                  <Label text="Show Payer Address" />
                  <div style={{ display: "flex", gap: 4 }}>
                    <Checkbox size="small" sx={{ padding: 0 }} />
                    <select style={selectStyle}>
                      <option>PRIMARY</option>
                      <option>SECONDARY</option>
                    </select>
                  </div>
                </div>
              </div>
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="1a. INSURED ID NUMBER/MEMBER ID" />
              <Input value={memberid} />
            </TableCell>
          </TableRow>

          {/* ================= ROW 2 ================= */}
          <TableRow>
            <TableCell sx={cellStyle}>
              <Label text="2. PATIENT'S NAME (Last, First)" />
              <div style={{ display: "flex", gap: 6 }}>
                <Input value={PatientName} />
                {/* <Input placeholder="First" /> */}
              </div>
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="3. PATIENT DOB /SEX" />
              <div style={{ display: "flex", gap: 6 }}>
                <Input type="date" value={patientDOB} />
                <select
                  style={selectStyle}
                  value={PatientSex || ""} // useState value
                  onChange={(e) => setPatientSex(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="4. INSURED'S NAME (Last, First)" />
              <div style={{ display: "flex", gap: 6 }}>
                <Input value={PatientName} />
                {/* <Input placeholder="First" /> */}
              </div>
            </TableCell>
          </TableRow>

          {/* ================= ROW 3 ================= */}
          <TableRow>
            <TableCell sx={cellStyle}>
              <Label text="5. PATIENT ADDRESS" />
              <Input placeholder="Street Address" value={patientAddress} />
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="6. PATIENT RELATIONSHIP TO INSURED" />
              <select
                style={selectStyle}
                value={PriRelation || ""}
                onChange={(e) => setPriRelation(e.target.value)}
              >
                <option value="">Select</option>
                <option value="Self">Self</option>
                <option value="Spouse">Spouse</option>
                <option value="Mother">Mother</option>
                <option value="Father">Father</option>
                <option value="Other">Other</option>
              </select>
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="7. INSURED ADDRESS" />
              <Input placeholder="Street Address" value={patientAddress} />
            </TableCell>
          </TableRow>

          {/* ================= ROW 4 ================= */}
          <TableRow>
            <TableCell sx={cellStyle}>
              <Label text=" ADDRESS 2" />
              <Input value={"Same as Above"} />
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="8. MARITAL STATUS" />
              <select style={selectStyle} defaultValue="">
                <option value="" disabled>
                  -- Select --
                </option>
                <option value="SINGLE"> SINGLE</option>
                <option value="MARRIED"> MARRIED</option>
              </select>
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text=" ADDRESS 2" />
              <Input value={"Same as Above"} />
            </TableCell>
          </TableRow>

          {/* ================= ROW 5 ================= */}
          <TableRow>
            <TableCell sx={cellStyle}>
                <div style={{ display: "flex", gap: 12 }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                  <Label text=" CITY " />
                <Input placeholder="City" value={patientCity} />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
              <Label text="ST " />
                <Input placeholder="ST" value={patientState} />
                      </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
              <Label text="ZIP " />
                <Input placeholder="ZIP" value={patienZip} />
              </div>
              </div>
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text=" EMPLOYMENT STATUS" />
              <select style={selectStyle} defaultValue="">
                <option value="" disabled>
                  -- Select --
                </option>
                <option>EMPLOYED</option>
                <option>UNEMPLOYED</option>
              </select>
            </TableCell>

            <TableCell sx={cellStyle}>
            <div style={{ display: "flex", gap: 12 }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                  <Label text=" CITY " />
                <Input placeholder="City" value={patientCity} />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
              <Label text="ST " />
                <Input placeholder="ST" value={patientState} />
                      </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
              <Label text="ZIP " />
                <Input placeholder="ZIP" value={patienZip} />
              </div>
              </div>
            </TableCell>
          </TableRow>

          {/* ================= ROW 6 ================= */}
          <TableRow>
            <TableCell sx={cellStyle}>
              <Label text="9. SECONDARY INSURED (L, F, M)" />
              <Input value={PatientName} />

              <Label text="a.SECONDRY INSURED'S POLICY " />
              <Input value={SecPayerId} />

              <Label text="b.SECONDRY INSURED'S DATE OF BIRTH/SEX" />
              <div style={{ display: "flex", gap: 6 }}>
                <Input type="date" value={patientDOB} />
              </div>
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="10. PATIENT CONDITION RELATED TO" />
              {["EMPLOYMENT", "AUTO ACCIDENT", "OTHER ACCIDENT"].map((t) => (
                <div key={t} style={{ display: "flex", gap: 6 }}>
                  <span style={{ fontSize: 11, width: 100 }}>{t}</span>
                  <select style={{ ...selectStyle, width: 70 }} defaultValue="">
                    <option value="" disabled>
                      -- Select --
                    </option>
                    <option value="NO">NO</option>
                    <option value="YES">YES</option>
                  </select>
                </div>
              ))}
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="11. INSURED POLICY GROUP / MEMBER ID" />
              <Input value={SecondarMemberid} />

              {/* <Label text="11a. DOB" /> */}
              <Label text="a.INSURED'S DATE OF BIRTH/SEX" />
              <div style={{ display: "flex", gap: 6 }}>
                <Input type="date" value={patientDOB} />
                <select
                  style={selectStyle}
                  value={PatientSex || ""} // useState value
                  onChange={(e) => setPatientSex(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                {/* <select style={selectStyle}>
                  <option>MALE</option>
                  <option>FEMALE</option>
                </select> */}
              </div>

              <Label text="b. EMPLOYER'S NAME" />
              <Input />
            </TableCell>
          </TableRow>

          {/* ================= ROW 7 ================= */}
          <TableRow>
            <TableCell sx={cellStyle}>
              <Label text="11c. PRIMARY PAYMENT DATE" />
              <Input type="date" />
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="10d. CLAIM CODES" />
              <Input />

              {/* <Label text="9e. RELATIONSHIP TO PATIENT" /> */}
              {/* <select style={selectStyle} /> */}
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="c. INSURANCE PLAN NAME" />
              <Input value={SecondarInsuranceName} />

              {/* <Label text="17. SUPERVISING PROVIDER NAME" />
              <Input /> */}

              {/* <div style={{ display: "flex", gap: 6 }}>
                <Input placeholder="ID" />
                <Input placeholder="NPI" />
              </div> */}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              <Label text="d.SECONDRY PAYER NAME    PAYER ID" />
               <div style={{ display: "flex", gap: 6 }}>
                 <Input value={SecondarInsuranceName} />
                 <Input value={SecPayerId} />
              </div>
                <Label text="SECONDARY PAYER CLAIM ID" />
              <Input value='' />
                <Label text="MEDICARE TYPE CODE" />
             <select style={selectStyle} defaultValue="">
                <option value="" disabled>
                  -- Select --
                </option>
              </select>

            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="9e. SECONDRY PATIENT RELATIONSHIP" />
              <select style={selectStyle}>
                <option>SELF</option>
                <option>SPOUSE</option>
                <option>MOTHER</option>
              </select>
                 <Label text="9f.SECONDARY PAYER GROUP NAME" />
              <Input value='' />
                 <Label text="9g.SECONDARY PAYER GROUP NUMBER" />
              <Input value='' />

              {/* <Label text="9e. RELATIONSHIP TO PATIENT" />
              <select style={selectStyle} /> */}
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text=" SUPERVISING PROVIDER NAME" />
              <select
                style={selectStyle}
                value={attendingPhysician || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setValue("attendingPhysician", selectedValue);

                  const selectedProvider = providers.find(
                    (p) => String(p.value) === String(selectedValue)
                  );

                  if (selectedProvider) {
                    setNpi(selectedProvider.npi || "");
                    setTaxId(selectedProvider.taxId || "");
                    setbillingProvider(selectedProvider.billingProvider)
                        setProviderAddress(selectedProvider.address);
        setProviderphone(selectedProvider.phone);
        setProviderZip(selectedProvider.zipCode);
        setProviderState(selectedProvider.state);
                  } else {
                    setNpi("");
                    setTaxId("");
                  }

                  setProviderError(false);
                }}
              >
                <option value="" disabled>
                  -- Select Provider --
                </option>

                {providers.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.label}
                  </option>
                ))}
              </select>

              {/* <Label text="17. SUPERVISING PROVIDER NAME" />
              <Input /> */}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  marginTop:'10PX'
                }}
              >
                <span
                  style={{
                    fontSize: 8,
                    minWidth: 30, // label fixed width
                    textAlign: "left",
                    fontWeight: "bold",
                  }}
                >
                  TAX ID
                </span>

                <Input placeholder="ID" value={taxId} style={{ flex: 1 }} />
                <span
                  style={{
                    fontSize: 8,
                    minWidth: 20, // label fixed width
                    textAlign: "left",
                    fontWeight: "bold",
                  }}
                >
                  NPI
                </span>
                <Input placeholder="NPI" value={npi} style={{ flex: 1 }} />
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cellStyle}>
              <Label text="14. DATE OF CONDITION" />
              <Input type="date" />
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="17. REFERRING PHYSICIAN NAME" />
              <select
                style={selectStyle}
                value={referringPhysician || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setValue("referringPhysician", selectedValue);

                  const selected = referringPhysicianList.find(
                    (p) => String(p.value) === String(referringPhysician)
                  );
                  if (selected) {
                    setReferringProviderNpi(selected.npi || "");
                  }
                }}
              >
                <option value="" disabled>
                  -- Select Physician --
                </option>

                {referringPhysicianList.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.label}
                  </option>
                ))}
              </select>

              {/* <Label text="9e. RELATIONSHIP TO PATIENT" />
              <select style={selectStyle} /> */}
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="17a. REFERRING PHYSICIAN NPI" />
              <Input
                placeholder="ID"
                value={referringProviderNpi}
                style={{ flex: 1 }}
              />
            </TableCell>
          </TableRow>

          {/* ================= ROW 8: ADD DATE FIELD ================= */}
          <TableRow>
            <TableCell colSpan={3} sx={cellStyle}>
              <Label text="ADD DATE FIELD" />
              <Input type="date" style={{ width: "150px" }} />
            </TableCell>
          </TableRow>

          {/* ================= ROW 9: 19. CLAIM NARRATIVE ================= */}
          <TableRow>
            <TableCell colSpan={3} sx={cellStyle}>
              <Label text="19. CLAIM NARRATIVE" />
              <textarea
                style={{
                  width: "100%",
                  minHeight: "80px",
                  border: "1px solid #ccc",
                  padding: "4px",
                  fontSize: "12px",
                  fontFamily: "inherit",
                }}
              />
            </TableCell>
          </TableRow>

          {/* ================= ROW 10: 21. DIAGNOSIS & 18. HOSPITALIZATION ================= */}
          <TableRow>
            <TableCell colSpan={2} sx={cellStyle}>
              <Label text="21. DIAGNOSIS OR NATURE OF ILLNESS OR INJURY (Relate to 24E by line)" />
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: 4,
                }}
              >
                {[
                  "A",
                  "B",
                  "C",
                  "D",
                  "E",
                  "F",
                  "G",
                  "H",
                  "I",
                  "J",
                  "K",
                  "L",
                ].map((letter) => (
                  <div
                    key={letter}
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    <span style={{ fontSize: "10px" }}>{letter}.</span>
                    <Input
                      value={diagnosisCodes[letter]}
                      onChange={(e) =>
                        handleDiagnosisCodeChange(letter, e.target.value)
                      }
                      placeholder={`DX${letter.charCodeAt(0) - 64}`}
                      style={{ width: "60px", height: "24px" }}
                    />
                  </div>
                ))}
              </div>
            </TableCell>

            <TableCell sx={cellStyle}>
              <Label text="18. HOSPITALIZATION DATES" />
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                     <span style={{ fontSize: "11px" }}>FROM</span>
                <Input type="date" style={{ width: "100px" }} />
                <span style={{ fontSize: "11px" }}>TO</span>
                <Input type="date" style={{ width: "100px" }} />
              </div>
              <Label text="22. RESUBMISSION CODE (Player ICN)" />
              <Input style={{ width: "100px" }} />
              <Label text="23. PRIOR AUTHORIZATION NUMBER" />
              <Input value={priorAuthorization} style={{ width: "100px" }} />
              <Label text="CLA NUMBER" />
              <Input style={{ width: "100px" }} />
            </TableCell>
          </TableRow>
          {/* ================= ROW 12: 24. SERVICES TABLE HEADER ================= */}
          {/* <TableRow>
            <TableCell colSpan={3} sx={{ ...cellStyle, padding: "4px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "0.8fr 0.5fr 0.5fr 1fr 0.6fr 0.6fr 0.8fr 0.8fr",
                  gap: "2px",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                <div> A. DOS</div>
                <div>B. POS</div>
                <div>C. PROCEDURES, SERVICES</div>
                <div>D. DIAGNOSIS</div>
                <div>E. CHARGES</div>
                <div> F. UNITS</div>
                <div>F. $ CHARGES</div>
                <div>G. UNITS</div>
              </div>
            </TableCell>
          </TableRow> */}
          <TableRow>
            <TableCell colSpan={3} sx={{ padding: 0 }}>
              <Table
                size="small"
                sx={{
                  tableLayout: "fixed",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                {/* ================= TABLE HEADER ================= */}
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "4px",
                        width: "10%",
                      }}
                    >
                      <span>
                        <b>24.{""}</b>
                      </span>{" "}
                      A. DOS
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "4px",
                        width: "8%",
                      }}
                    >
                      B. POS
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "4px",
                        width: "20%",
                      }}
                    >
                      C. PROCEDURES, SERVICES
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "4px",
                        width: "20%",
                      }}
                    >
                      D. DIAGNOSIS
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "4px",
                        width: "10%",
                      }}
                    >
                      E. CHARGES
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "4px",
                        width: "8%",
                      }}
                    >
                      F. UNITS
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "4px",
                        width: "10%",
                      }}
                    >
                      F. $ CHARGES
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #000",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "10px",
                        padding: "4px",
                        width: "8%",
                      }}
                    >
                      G. UNITS
                    </TableCell>
                  </TableRow>
                </TableHead>

                {/* ================= TABLE BODY ================= */}
                <TableBody>
                  {[0, 1, 2, 3].map((index) => {
                    const rowData = [
                      {
                        dos,
                        pos: code,
                        procedure: code,
                        diagnosis: d,
                        charges,
                        unit: UNIT,
                      },
                      {
                        dos: dos1,
                        pos: code2,
                        procedure: code1,
                        diagnosis: d1,
                        charges: charges1,
                        unit: UNIT1,
                      },
                      {
                        dos: dos2,
                        pos: code3,
                        procedure: code2,
                        diagnosis: d2,
                        charges: charges2,
                        unit: UNIT2,
                      },
                      {
                        dos: dos3,
                        pos: code2,
                        procedure: code3,
                        diagnosis: d3,
                        charges: charges3,
                        unit: UNIT3,
                      },
                    ][index];

                    return (
                      <TableRow key={index}>
                        {/* A. DOS */}
                        <TableCell
                          sx={{ border: "1px solid #000", padding: "2px" }}
                        >
                          <Input
                            size="small"
                            type="date"
                            value={rowData.dos}
                            onChange={(e) => {
                              if (index === 0) setDos(e.target.value);
                              else if (index === 1) setDos1(e.target.value);
                              else if (index === 2) setDos2(e.target.value);
                              else setDos3(e.target.value);
                            }}
                            variant="standard"
                            sx={{ width: "100%", height: "24px" }}
                          />
                        </TableCell>

                        {/* B. POS */}
                        <TableCell
                          sx={{ border: "1px solid #000", padding: "2px" }}
                        >
                          <Input
                            size="small"
                            value={
                              procedureCodeList.find(
                                (opt) => opt.value === rowData.pos
                              )?.placeOfService || ""
                            }
                            variant="standard"
                            sx={{ width: "100%", height: "24px" }}
                          />
                        </TableCell>

                        {/* C. PROCEDURES */}
                        <TableCell
                          sx={{ border: "1px solid #000", padding: "2px" }}
                        >
                          <ReactSelect
                            value={procedureCodeList.find(
                              (opt) => opt.value === rowData.procedure
                            )}
                            onChange={(selectedOption) => {
                              if (selectedOption) {
                                if (index === 0) {
                                  setCode(selectedOption.value);
                                  setCharges(selectedOption.qasim);
                                  setUNIT(selectedOption.unit);
                                  setValue("cpt1", selectedOption.value);
                                } else if (index === 1) {
                                  setCode1(selectedOption.value);
                                  setCharges1(selectedOption.qasim);
                                  setUNIT1(selectedOption.unit);
                                  setValue("cpt2", selectedOption.value);
                                } else if (index === 2) {
                                  setCode2(selectedOption.value);
                                  setCharges2(selectedOption.qasim);
                                  setUNIT2(selectedOption.unit);
                                  setValue("cpt3", selectedOption.value);
                                } else {
                                  setCode3(selectedOption.value);
                                  setCharges3(selectedOption.qasim);
                                  setUNIT3(selectedOption.unit);
                                }
                              } else {
                                if (index === 0) {
                                  setCode("");
                                  setCharges("");
                                  setUNIT("");
                                  setValue("cpt1", "");
                                } else if (index === 1) {
                                  setCode1("");
                                  setCharges1("");
                                  setUNIT1("");
                                  setValue("cpt2", "");
                                } else if (index === 2) {
                                  setCode2("");
                                  setCharges2("");
                                  setUNIT2("");
                                  setValue("cpt3", "");
                                } else {
                                  setCode3("");
                                  setCharges3("");
                                  setUNIT3("");
                                }
                              }
                            }}
                            options={procedureCodeList}
                            styles={simpleSelectStyle}
                            menuPortalTarget={document.body}
                          />
                        </TableCell>

                        {/* D. DIAGNOSIS */}
                        <TableCell
                          sx={{ border: "1px solid #000", padding: "2px" }}
                        >
                          <ReactSelect
                            isMulti
                            value={rowData.diagnosis.map((dxCode) => {
                              const option = diagnosisList.find(
                                (item) => String(item.value) === String(dxCode)
                              );
                              return {
                                label: option ? option.label : dxCode,
                                value: dxCode,
                              };
                            })}
                            onChange={(selectedOptions) => {
                              const selectedValues = selectedOptions
                                ? selectedOptions.map((opt) =>
                                    String(opt.value)
                                  )
                                : [];
                              if (index === 0) setD(selectedValues);
                              else if (index === 1) setD1(selectedValues);
                              else if (index === 2) setD2(selectedValues);
                              else setD3(selectedValues);
                            }}
                            options={diagnosisList}
                            styles={simpleSelectStyle}
                            menuPortalTarget={document.body}
                          />
                        </TableCell>

                        {/* E. CHARGES */}
                        <TableCell
                          sx={{ border: "1px solid #000", padding: "2px" }}
                        >
                          <Input
                            size="small"
                            value={rowData.charges}
                            onChange={(e) => {
                              if (index === 0) setCharges(e.target.value);
                              else if (index === 1) setCharges1(e.target.value);
                              else if (index === 2) setCharges2(e.target.value);
                              else setCharges3(e.target.value);
                            }}
                            variant="standard"
                            sx={{ width: "100%", height: "24px" }}
                          />
                        </TableCell>

                        {/* F. UNITS */}
                        <TableCell
                          sx={{ border: "1px solid #000", padding: "2px" }}
                        >
                          <Input
                            size="small"
                            value={rowData.unit}
                            InputProps={{ readOnly: true }}
                            variant="standard"
                            sx={{ width: "100%", height: "24px" }}
                          />
                        </TableCell>

                        {/* F. $ CHARGES */}
                        <TableCell
                          sx={{ border: "1px solid #000", padding: "2px" }}
                        >
                          <Input
                            size="small"
                            value={rowData.charges}
                            variant="standard"
                            sx={{ width: "100%", height: "24px" }}
                          />
                        </TableCell>

                        {/* G. UNITS */}
                        <TableCell
                          sx={{ border: "1px solid #000", padding: "2px" }}
                        >
                          <Input
                            size="small"
                            value={rowData.unit}
                            InputProps={{ readOnly: true }}
                            variant="standard"
                            sx={{ width: "100%", height: "24px" }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={3} sx={{ padding: 0 }}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr", // 6 columns for your fields
                  border: "1px solid #000", // outer border
                }}
              >
                {/* TAX I.D */}
                <Box
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    padding: "4px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                    25.TAX I.D
                  </Typography>
                  <Input
                    size="small"
                    value={taxId}
                    variant="standard"
                    sx={{ height: "24px", fontSize: 11 }}
                  />
                </Box>

                {/* PATIENT'S ACCOUNT # */}
                <Box
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    padding: "4px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                    26.PATIENT'S ACCOUNT #
                  </Typography>
                  <Input
                    size="small"
                    value={patientid}
                    variant="standard"
                    sx={{ height: "24px", fontSize: 11 }}
                  />
                </Box>

                {/* ACCEPT ASSIGNMENT */}
                <Box
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    padding: "4px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                    27.ACCEPT ASSIGNMENT
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="radio"
                        id="acceptYes"
                        checked={acceptAssignment === true}
                        style={{ marginRight: "3px" }}
                        onClick={() => {
                          setValue("acceptAssignment", true);
                          setValue("dontAcceptAssignment", false);
                        }}
                      />
                      <label htmlFor="acceptYes" style={{ fontSize: "11px" }}>
                        YES
                      </label>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="radio"
                        id="acceptNo"
                        checked={dontAcceptAssignment === true}
                        style={{ marginRight: "3px" }}
                        onClick={() => {
                          setValue("dontAcceptAssignment", true);
                          setValue("acceptAssignment", false);
                        }}
                      />
                      <label htmlFor="acceptNo" style={{ fontSize: "11px" }}>
                        NO
                      </label>
                    </Box>
                  </Box>
                </Box>

                {/* TOTAL CHARGES */}
                <Box
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    padding: "4px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                    28.TOTAL CHARGES
                  </Typography>
                  <Input
                    size="small"
                    value={`$${totalCharge}`}
                    InputProps={{ readOnly: true }}
                    variant="standard"
                    sx={{ height: "24px", fontSize: 11 }}
                  />
                </Box>

                {/* AMOUNT PAID */}
                <Box
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    padding: "4px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                    29.AMOUNT PAID
                  </Typography>
                  <Input
                    size="small"
                    value={amountPaid}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9.]/g, "");
                      setAmountPaid(value);
                    }}
                    variant="standard"
                    sx={{ height: "24px", fontSize: 11 }}
                  />
                </Box>

                {/* BALANCE DUE */}
                <Box
                  sx={{
                    borderBottom: "1px solid #000",
                    padding: "4px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography sx={{ fontSize: 11, fontWeight: "bold" }}>
                    30.BALANCE DUE
                  </Typography>
                  <Input
                    size="small"
                    value={`$${balanceDue}`}
                    InputProps={{ readOnly: true }}
                    variant="standard"
                    sx={{ height: "24px", fontSize: 11 }}
                  />
                </Box>
              </Box>
            </TableCell>
          </TableRow>
          {/* ================= ROW 16: 31. RENDERING PROVIDER ================= */}
          <TableRow>
            <TableCell sx={cellStyle}>
              <Label text="31. RENDERING PROVIDER (Last, First, Middle)" />
              <select
                style={selectStyle}
                value={attendingPhysician || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setValue("attendingPhysician", selectedValue);

                  const selectedProvider = providers.find(
                    (p) => String(p.value) === String(selectedValue)
                  );

                  if (selectedProvider) {
                    setNpi(selectedProvider.npi || "");
                    setTaxId(selectedProvider.taxId || "");
                    setbillingProvider(selectedProvider.billingProvider)
                                     setProviderAddress(selectedProvider.address);
        setProviderphone(selectedProvider.phone);
        setProviderZip(selectedProvider.zipCode);
        setProviderState(selectedProvider.state);
                  } else {
                    setNpi("");
                    setTaxId("");
                  }

                  setProviderError(false);
                }}
              >
                <option value="" disabled>
                  -- Select Physician --
                </option>

                {providers.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.label}
                  </option>
                ))}
              </select>

              {/* <Label text="17. SUPERVISING PROVIDER NAME" />
              <Input /> */}

              <Label text="TAX ID" />
              <Input placeholder="ID" value={taxId} style={{ flex: 1 }} />
              <Label text="NPI" />

              <Input placeholder="NPI" value={npi} style={{ flex: 1 }} />
            </TableCell>
            <TableCell sx={cellStyle}>
              <Label text="32. SERVICE FACILITY LOCATION INFORMATION" />
              <Label text=" FACILTY" />
              <Input value={PracticeName} />
              <Label text="ADRESS LINE 1" />
              <Input value={PracticeAddress} />
              <Label text="City St Zip C" />
              <Input
                value={`${PracticeZipcode.city}, ${PracticeZipcode.state}, ${PracticeZipcode.zipCode}`}
              />
            </TableCell>
            <TableCell sx={cellStyle}>
              <Label text="33. BILLING PROVIDER" />
              {/* <div style={{ display: "flex", gap: 12 }}>
                <div style={{ flex: 2 }}>
                  <div style={{ fontSize: "10px" }}>Provider Name</div>
                  <Input  />

                  <div style={{ fontSize: "10px", marginTop: "4px" }}>
                    Address 1
                  </div>
                  <Input  />

                  <div style={{ fontSize: "10px", marginTop: "4px" }}>
                    Address 2
                  </div>
                  <Input />
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "10px" }}>City St Zip</div>
                  <Input  />
                  <Input style={{ marginTop: "4px" }} />
                  <Input style={{ marginTop: "4px" }} />

                  <div style={{ fontSize: "10px", marginTop: "4px" }}>
                    Phone
                  </div>
                  <Input  />
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "10px" }}>Taxonomy</div>
                  <Input />

                  <div style={{ fontSize: "10px", marginTop: "8px" }}>
                    MPI / PROV ID / FACIL ID / BILL ID
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 4,
                      marginTop: "4px",
                    }}
                  >
                    <Input placeholder="MPI" />
                    <Input placeholder="PROV ID" />
                    <Input placeholder="FACIL ID" />
                    <Input placeholder="BILL ID" />
                  </div>
                </div>
              </div> */}
            <select
  style={selectStyle}
  value={billingProvider ? attendingPhysician : ""}
  onChange={(e) => {
    const selectedValue = e.target.value;
    setValue("attendingPhysician", selectedValue);

    const selectedProvider = providers.find(
      (p) => String(p.value) === String(selectedValue)
    );

    if (selectedProvider) {
      setNpi(selectedProvider.npi || "");
      setTaxId(selectedProvider.taxId || "");
      setbillingProvider(selectedProvider.billingProvider);
      setProviderAddress(selectedProvider.address || "");
      setProviderphone(selectedProvider.phone || "");
      setProviderZip(selectedProvider.zipCode || "");
      setProviderState(selectedProvider.state || "");
    } else {
      setNpi("");
      setTaxId("");
      setProviderAddress("");
      setProviderphone("");
      setProviderZip("");
      setProviderState("");
    }

    setProviderError(false);
  }}
>
  <option value="" disabled>
    -- Select Provider --
  </option>
  {providers.map((p) => (
    <option key={p.value} value={p.value}>
      {p.label}
    </option>
  ))}
</select>

{/* Provider Details */}
<div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginTop: 2 }}>
  <div style={{ flex: 1, minWidth: 120 }}>
    <label style={{ fontSize: 8, fontWeight: "bold" }}>TAX ID</label>
    <Input placeholder="ID" value={billingProvider ? taxId : ""} />
  </div>

  <div style={{ flex: 1, minWidth: 120 }}>
    <label style={{ fontSize: 8, fontWeight: "bold" }}>NPI</label>
    <Input placeholder="NPI" value={billingProvider ? npi : ""} />
  </div>

  <div style={{ flex: 1, minWidth: 200 }}>
    <label style={{ fontSize: 8, fontWeight: "bold" }}>Address</label>
    <Input placeholder="Address" value={billingProvider ? ProviderAddress : ""} />
  </div>

  <div style={{ flex: 1, minWidth: 80 }}>
    <label style={{ fontSize: 8, fontWeight: "bold" }}>State</label>
    <Input placeholder="State" value={billingProvider ? ProviderState : ""} />
  </div>

  <div style={{ flex: 1, minWidth: 100 }}>
    <label style={{ fontSize: 8, fontWeight: "bold" }}>Zip Code</label>
    <Input placeholder="Zip" value={billingProvider ? ProviderZip : ""} />
  </div>

  <div style={{ flex: 1, minWidth: 120 }}>
    <label style={{ fontSize: 8, fontWeight: "bold" }}>Phone</label>
    <Input placeholder="Phone" value={billingProvider ? Providerphone : ""} />
  </div>
</div>

            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
};

export default PreviewClaim;
